import { render, staticRenderFns } from "./ActivityTable.vue?vue&type=template&id=60244abe&scoped=true"
import script from "./ActivityTable.vue?vue&type=script&lang=js"
export * from "./ActivityTable.vue?vue&type=script&lang=js"
import style0 from "./ActivityTable.vue?vue&type=style&index=0&id=60244abe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60244abe",
  null
  
)

export default component.exports